module.exports = __webpack_public_path__ + "static/media/b8-圆津禅院.de01b38f.png";